import React from "react";
import {Formik} from "formik";
import {EventTriggerForm} from "../../services/HubAndSpokeService";
import {EventTriggersFormFields} from "./EventTriggersFormFields";
import {useCreateEventTrigger} from "./hooks/useCreateEventTrigger";
import {HubAndSpokePage} from "./atoms/HubAndSpokePage";
import {FormCardWrapper} from "./styles";
import {validate} from "./helpers";
import {WorkflowType} from "../../utils/enums";

const DOCUMENT_PATH =
  "{facility-name}/example_form_{current-date}-{resident-name}.pdf";

export const EventTriggerCreate = () => {
  const {mutate: createEventTrigger, isLoading: isCreating} =
    useCreateEventTrigger();

  return (
    <HubAndSpokePage title="New Event Trigger">
      <FormCardWrapper>
        <Formik<EventTriggerForm>
          enableReinitialize
          initialValues={{
            templateName: "",
            workflowType: WorkflowType.ADMISSION,
            document: "",
            template_field_id: "",
            facilities: [],
            sftp_config_id: "",
            document_path: DOCUMENT_PATH,
            upload_on: ["admission_approval"],
          }}
          // Empty onSubmit due to a Formik issue; the form submits itself.
          // https://github.com/jaredpalmer/formik/issues/2675
          onSubmit={() => {
            return;
          }}
          validate={validate}
        >
          <EventTriggersFormFields
            isLoading={isCreating}
            onSubmit={values => createEventTrigger(values)}
          />
        </Formik>
      </FormCardWrapper>
    </HubAndSpokePage>
  );
};
